import { api } from 'app/config/apiConfig';
import { AddUserNoteParams } from '../model/types';
import { USERS_PATH } from '../utils/constants';

export const addUserNoteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addUserNote: builder.mutation<void, { userId: string; params: AddUserNoteParams }>({
      query: ({ userId, params }) => ({
        url: `${USERS_PATH}/${userId}/note`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const { useAddUserNoteMutation } = addUserNoteApi;
